import { HttpBackend, HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import {
  TECH_LIB_PORTAL_CONFIG,
  TechLibPortalConfig,
} from '../../../tech-lib-portal.interceptor';
import { EditDataEnum } from '../../../services/api-names';
import { EditClientData } from '../request/models/edit-client-data.model';

@Injectable({
  providedIn: 'root',
})
export class EditDataService {
  constructor(
    @Inject(TECH_LIB_PORTAL_CONFIG) private config: TechLibPortalConfig,
    private httpBackend: HttpBackend,
    private http: HttpClient
  ) {}

  public getEditClientData() {
    const url = this.config.baseApi + EditDataEnum.client_edit_data;
    return this.http.get<any>(url).pipe(
      map((res) => {
        return res.NaturalClient;
      }),
      catchError((err) => {
        return throwError(err);
      })
    );
  }

  public setEditClientData(editClientData: EditClientData) {
    const url = this.config.baseApi + EditDataEnum.client_edit_data;
    const bodyRequest =
      '{"NaturalClient": ' + JSON.stringify(editClientData) + '}';

    return this.http.post<any>(url, bodyRequest).pipe(
      map((res) => {
        return res.NaturalClient;
      }),
      catchError((err) => {
        return throwError(err);
      })
    );
  }
}
